import React, { PropsWithChildren } from 'react';
import * as S from './Badge.styles';

export const Badge = ({
  children,
  hasIcon,
}: PropsWithChildren<{ hasIcon?: boolean }>) => {
  if (!hasIcon) {
    return children;
  }

  return (
    <S.BadgeBox>
      <S.BadgeIcon data-testid="badge-icon" />
      {children}
    </S.BadgeBox>
  );
};
